/* Luvia native rebuild — small runtime for variant selection + click-to-play video.
   Add-to-cart itself is handled by the theme's own <product-form> element + cart drawer. */
(function () {
  'use strict';

  // ---- Variant selector: clicking a version card updates the form's hidden variant id ----
  function initBuybox(root) {
    var form = root.querySelector('form[data-type="add-to-cart-form"]') || root.querySelector('form');
    var idInput = root.querySelector('.product-variant-id');
    var options = root.querySelectorAll('[data-lv-variant]');
    if (!options.length || !idInput) return;

    function select(card) {
      options.forEach(function (o) {
        var on = o === card;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      idInput.value = card.getAttribute('data-lv-variant');
      // update any price mirrors in the ATC button
      var price = card.getAttribute('data-lv-price');
      root.querySelectorAll('[data-lv-price-target]').forEach(function (el) {
        if (price) el.textContent = price;
      });
      // The anniversary bundle is "this variant + the mask", so its price, its
      // compare-at, its saving and its image all depend on which version is selected.
      // Each variant card carries the bundle values it implies.
      // NB: the SOURCE attributes live on the variant card and the TARGET hooks use
      // distinct `-out-` names. They must never collide, or querySelector finds the
      // variant card itself and textContent wipes out the card's markup.
      var map = {
        'data-lv-bundle-price': '[data-lv-out-bundle-price]',
        'data-lv-bundle-compare': '[data-lv-out-bundle-compare]',
        'data-lv-bundle-save': '[data-lv-out-bundle-save]'
      };
      // Where a variant has no bundle override configured, fall back to the section
      // default rather than leaving the previously-selected variant's value on screen.
      // Looked up on the DOCUMENT, not inside the buy box: on the PDP the bundle block sits
      // in the buy box, but on the homepage it is a separate section further down the page.
      Object.keys(map).forEach(function (attr) {
        var el = document.querySelector(map[attr]);
        if (!el) return;
        if (el.dataset.lvDefault === undefined) el.dataset.lvDefault = el.textContent;
        el.textContent = card.getAttribute(attr) || el.dataset.lvDefault;
      });
      // Announce the selection so sections OUTSIDE the buy box can react (the electrode
      // grid swaps its art per version). A document-level event keeps those sections
      // decoupled — they never reach into the hero's DOM.
      var idx = Array.prototype.indexOf.call(options, card);
      document.dispatchEvent(new CustomEvent('lv:variant-change', {
        detail: {
          index: idx,
          id: card.getAttribute('data-lv-variant'),
          hero: card.getAttribute('data-lv-hero'),
          // Already money-formatted by Liquid, so Shopify Markets has converted it to the
          // visitor's currency. Down-page CTAs mirror this string — never re-format it in JS.
          price: card.getAttribute('data-lv-price')
        }
      }));

      var bimgEl = root.querySelector('[data-lv-out-bundle-img]');
      if (bimgEl) {
        if (bimgEl.dataset.lvDefault === undefined) bimgEl.dataset.lvDefault = bimgEl.src;
        bimgEl.src = card.getAttribute('data-lv-bundle-image') || bimgEl.dataset.lvDefault;
      }
    }

    options.forEach(function (card) {
      card.setAttribute('role', 'radio');
      card.addEventListener('click', function () { select(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(card); }
      });
    });

    // select the pre-marked default (or first)
    var pre = root.querySelector('[data-lv-variant].is-selected') || options[0];
    if (pre) select(pre);

    // ---- Bundle add-on ----
    // The anniversary bundle is two real line items (wand variant + mask), not a bundle
    // product; a Shopify AUTOMATIC discount then fires because both are in the cart. The
    // theme's <product-form> can only post one item, so when the bundle box is ticked we
    // take over the submit and POST both via /cart/add.js, then hand back to the theme so
    // its cart drawer opens exactly as it normally would.
    var bundleBox = root.querySelector('[data-lv-bundle]');
    if (form && bundleBox && !form.dataset.lvBundleBound) {
      form.dataset.lvBundleBound = '1';
      // CAPTURE on the document, not a listener on the form: <product-form> has its own
      // submit handler bound to the form, and a second handler there still lets the theme
      // post the wand on its own — the wand landed in the cart TWICE (qty 2 wand, qty 1
      // mask). Capturing at the document runs before any listener on the form, so
      // stopImmediatePropagation keeps the theme out of it entirely.
      document.addEventListener('submit', function (e) {
        if (e.target !== form || !bundleBox.checked) return;  // untouched → normal submit
        var maskId = bundleBox.getAttribute('data-lv-bundle-variant');
        if (!maskId) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart([idInput.value, maskId], form.querySelector('[name="add"]'));
      }, true);
    }
  }

  // ---- Add several variants in one request, then hand back to the theme's cart drawer ----
  // Used by both bundle entry points (the PDP buy-box tick box and the homepage bundle card).
  // Shopify applies the automatic bundle discount because both line items land in the cart.
  function addToCart(ids, btn) {
    var items = ids.filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
    if (!items.length) return;
    if (btn) btn.setAttribute('aria-busy', 'true');

    // The drawer's markup is rendered by Liquid at page load, so after a background add it
    // still says "your cart is empty" — the items are really in the cart, the drawer just
    // never re-rendered. Asking /cart/add.js for the drawer's own sections and handing them
    // to renderContents() is exactly what the theme's own add-to-cart does.
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var payload = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        // Announce the change first, so the cart bubble and any listening app update too.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lv-bundle' });
        }
        if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
          // `is-empty` is baked onto the drawer element by Liquid when the page was served.
          // renderContents swaps the inner HTML but leaves that class, which hides the items
          // we just added — so clear it ourselves. renderContents also opens the drawer.
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
          return;
        }
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = '/cart';
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  // ---- Bundle card CTA (homepage): adds the wand version the buy box currently has
  // selected PLUS the mask, in one request, and opens the drawer. It reads the live
  // variant id out of the buy box rather than keeping its own copy, so the card can never
  // drift from what the visitor picked. With no buy box on the page it falls back to the
  // default variant baked into the button. ----
  function initBundleAdd(btn) {
    // boot() runs on DOMContentLoaded AND on every shopify:section:load. Binding twice here
    // posts the cart twice — it showed up as quantity 2 of each line item.
    if (btn.dataset.lvBound) return;
    btn.dataset.lvBound = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var picked = document.querySelector('[data-lv-buybox] .product-variant-id');
      var wandId = (picked && picked.value) || btn.getAttribute('data-lv-wand-variant');
      addToCart([wandId, btn.getAttribute('data-lv-bundle-variant')], btn);
    });
  }

  // ---- Click-to-play video (UGC tiles): poster until tapped, then plays with sound ----
  // Loading is staged so the page stays light but playback still starts fast:
  //   1. markup ships preload="none"  -> zero video bytes on first paint
  //   2. tile scrolls into view       -> preload="metadata" (headers + first frame only)
  //   3. pointer/touch intent         -> preload="auto" + load(), buffering starts BEFORE
  //                                      the tap completes, which removes most of the delay
  //   4. click                        -> play()
  // Steps 2 and 3 are the whole trick: by the time the click event fires the browser has
  // usually already buffered enough to start, so playback feels instant without the tile
  // costing anything at page load.
  function initVideo(wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    var warmed = false;

    function warm() {
      if (warmed) return;
      warmed = true;
      video.preload = 'auto';
      video.load();
    }

    // 2. cheap metadata fetch once the tile is actually on screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (video.preload === 'none') video.preload = 'metadata';
          io.unobserve(e.target);
        });
      }, { rootMargin: '200px' });
      io.observe(wrap);
    } else {
      video.preload = 'metadata';
    }

    // 3. warm on intent. touchstart fires well before click on mobile; pointerenter
    //    covers desktop hover. passive so we never block scrolling.
    wrap.addEventListener('pointerenter', warm, { passive: true });
    wrap.addEventListener('touchstart', warm, { passive: true });

    // 4. play with sound (a real user gesture, so unmuted playback is allowed).
    //    Native controls give pause/scrub/volume for free.
    wrap.addEventListener('click', function () {
      if (wrap.classList.contains('is-playing')) return;
      warm();
      wrap.classList.add('is-playing');
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }, { once: true });
  }

  // ---- Shared drag/swipe: touch + mouse. getIndex()/go(i) drive a flex track ----
  function addDrag(track, getIndex, go) {
    var startX = 0, dx = 0, dragging = false, width = 0;
    function down(x) {
      dragging = true; startX = x; dx = 0;
      width = track.offsetWidth || 1;
      track.style.transition = 'none';
    }
    function move(x) {
      if (!dragging) return;
      dx = x - startX;
      track.style.transform = 'translateX(' + (-getIndex() * 100 + (dx / width) * 100) + '%)';
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      var threshold = width * 0.15;
      if (dx > threshold) go(getIndex() - 1);
      else if (dx < -threshold) go(getIndex() + 1);
      else go(getIndex());
    }
    track.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchend', up);
    track.addEventListener('touchcancel', up);
    track.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', up);
  }

  // ---- Gallery: swipeable carousel + thumbnail nav ----
  function initGallery(root) {
    var track = root.querySelector('[data-lv-track]');
    if (!track) return;
    var count = track.children.length;
    if (!count) return;
    var thumbs = root.querySelectorAll('[data-lv-thumb-index]');
    var counter = root.querySelector('[data-lv-counter]');
    var index = 0;
    var ends = function () {};

    function go(i) {
      index = Math.max(0, Math.min(count - 1, i));
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-lv-thumb-index'), 10) === index);
      });
      if (counter) counter.textContent = 'Slide ' + (index + 1) + ' of ' + count;
      // The thumb rail only shows ~4 at a time on mobile, so keep the active one in view.
      var active = thumbs[index];
      if (active && active.parentNode && active.parentNode.scrollWidth > active.parentNode.clientWidth) {
        var rail = active.parentNode;
        var target = active.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
      ends();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-lv-thumb-index'), 10)); });
    });

    // Prev/next carets. No wrap-around: at either end the caret disables and greys out
    // so the control tells you where you are in the set.
    var prev = root.querySelector('[data-lv-prev]');
    var next = root.querySelector('[data-lv-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    ends = function () {
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
    };

    // Selecting a version swaps the first slide to that version's hero shot and rewinds
    // the carousel, so the gallery always opens on the product you just chose.
    document.addEventListener('lv:variant-change', function (e) {
      var hero = e.detail && e.detail.hero;
      if (hero && track.children[0]) {
        var slideImg = track.children[0].querySelector('img');
        if (slideImg) slideImg.src = hero;
        var thumbImg = thumbs[0] && thumbs[0].querySelector('img');
        if (thumbImg) thumbImg.src = hero;
      }
      go(0);
    });

    addDrag(track, function () { return index; }, go);
    go(0);
  }

  // ---- Testimonials: swipeable card carousel with dots ----
  function initTesti(root) {
    var track = root.querySelector('[data-lv-testi-track]');
    if (!track) return;
    var count = track.children.length;
    if (!count) return;
    var dots = root.querySelectorAll('[data-lv-testi-index]');
    var index = 0;

    function go(i) {
      index = Math.max(0, Math.min(count - 1, i));
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-lv-testi-index'), 10) === index);
      });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-lv-testi-index'), 10)); });
    });
    addDrag(track, function () { return index; }, go);
    go(0);
  }

  // ---- Simple swap gallery (offer buy box): click a thumb → main image swaps ----
  function initSwapGallery(root) {
    var main = root.querySelector('[data-lv-gallery-main] img');
    var thumbs = root.querySelectorAll('[data-lv-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-lv-thumb');
        if (src) main.src = src;
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });
  }

  // ---- Modal: a trigger opens the dialog named by data-lv-modal-open ----
  // Uses <dialog> so Esc-to-close, focus trapping and the backdrop are native.
  function initModal(trigger) {
    var dlg = document.getElementById(trigger.getAttribute('data-lv-modal-open'));
    if (!dlg) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    });
    dlg.querySelectorAll('[data-lv-modal-close]').forEach(function (b) {
      b.addEventListener('click', function () { dlg.close(); });
    });
    // click the backdrop (i.e. the dialog element itself, outside its content) to dismiss
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  // ---- Version-linked images: swap art when the buy box announces a variant change ----
  // Each image carries data-lv-img-0/1/2 (Clear / Pro / Ultimate). Missing entries fall
  // back to index 0, so a version that reuses the default art needs no attribute.
  function initVariantImages(img) {
    var srcs = [0, 1, 2].map(function (i) { return img.getAttribute('data-lv-img-' + i); });
    document.addEventListener('lv:variant-change', function (e) {
      var next = srcs[e.detail.index] || srcs[0];
      if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
    });
  }

  // ---- Version-linked text: same idea as the images, but swaps innerHTML so headings
  // keep their <em> accent. Falls back to the index-0 copy. ----
  function initVariantText(el) {
    var txt = [0, 1, 2].map(function (i) { return el.getAttribute('data-lv-text-' + i); });
    document.addEventListener('lv:variant-change', function (e) {
      var next = txt[e.detail.index] || txt[0];
      if (next != null && el.innerHTML !== next) el.innerHTML = next;
    });
  }

  // ---- Price-bearing CTAs: a down-page button whose label quotes the price of the
  // version currently selected in the buy box. The element carries a template with a
  // [price] token (square brackets, not braces — a literal `}` would close the Liquid
  // output tag). The price string comes straight from the buy box, so it is whatever
  // Shopify Markets rendered for this visitor's currency. ----
  function initVariantPriceLabel(el) {
    var tpl = el.getAttribute('data-lv-price-tpl') || '';
    document.addEventListener('lv:variant-change', function (e) {
      var price = e.detail && e.detail.price;
      if (!price) return;
      var next = tpl.replace('[price]', price);
      if (el.textContent !== next) el.textContent = next;
    });
  }

  // ---- Version-gated blocks: hidden unless the selected version index is >= the
  // block's data-lv-min-version (Clear ships 4 electrodes, Pro/Ultimate add 2). ----
  function initVariantGate(el) {
    var min = parseInt(el.getAttribute('data-lv-min-version'), 10) || 0;
    document.addEventListener('lv:variant-change', function (e) {
      el.hidden = e.detail.index < min;
    });
  }

  // ---- Rating → reviews. Scrolls to the Loox section rather than linking, so it works
  // wherever that section sits in the template. ----
  function initScrollToReviews(btn) {
    btn.addEventListener('click', function () {
      var target = document.querySelector('[id*="__reviews"]')
                || document.querySelector('#looxReviews, .loox-reviews-default, [class*="loox"]');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // The theme's header is sticky, so every programmatic scroll has to clear it or the
  // target lands underneath.
  function headerHeight() {
    var head = document.querySelector('.shopify-section-group-header-group, header');
    return head ? head.getBoundingClientRect().height : 0;
  }

  // ---- Down-page CTAs scroll instead of navigating. ----
  // Every CTA below the fold is a "buy" button, but each one still carries a real href (the
  // product URL, or `#`) so it works with JS off and reads as a link to crawlers. With JS on,
  // navigating is wrong: it reloads the page just to land on the same buy box. Delegated at
  // the document so new sections need no wiring. Three cases:
  //   href="#section-id" → smooth-scroll to that element (the hero CTA aims at the carousel)
  //   href="#" / "" / this page's product → scroll to the buy box
  //   anything else, or a link marked data-lv-nav → left alone, navigates normally
  // `data-lv-nav` is what keeps the product-card grid working: those tiles link to OTHER
  // products and must still navigate.
  function initBuyScroll() {
    // boot() re-runs on every shopify:section:load; a delegated listener must bind once.
    if (document.documentElement.dataset.lvBuyScroll) return;
    document.documentElement.dataset.lvBuyScroll = '1';
    document.addEventListener('click', function (e) {
      var box = document.querySelector('[data-lv-buybox]');
      var a = e.target.closest && e.target.closest('a.lv-btn');
      if (!a || a.closest('[data-lv-nav]')) return;
      if (box && box.contains(a)) return;
      var href = a.getAttribute('href') || '';

      // Named in-page anchor: scroll there, clear of the sticky header.
      if (href.length > 1 && href.charAt(0) === '#') {
        var anchor = document.getElementById(href.slice(1));
        if (!anchor) return;
        e.preventDefault();
        window.scrollTo({
          top: Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - headerHeight() - 12),
          behavior: 'smooth'
        });
        return;
      }

      if (!box) return; // no buy box on this page — leave every link alone
      var selfLink = href === '' || href === '#' || href.indexOf('/products/') === 0;
      if (!selfLink) return;
      e.preventDefault();
      // The header is sticky, so scrollIntoView would slide the buy box under it.
      var offset = headerHeight();
      var top = box.getBoundingClientRect().top + window.scrollY - offset - 12;
      // Landing on the buy box's top edge leaves Add To Cart hanging just off the bottom on
      // a phone. Scroll far enough that the button is fully in frame, but never so far that
      // the version selector goes under the header — the point is to see all three at once.
      var atc = box.querySelector('.lv-ph__atc, .lv-of__atc');
      var picker = box.querySelector('.lv-ph__variants, .lv-of__variants');
      if (atc) {
        var reveal = atc.getBoundingClientRect().bottom + window.scrollY + 20 - window.innerHeight;
        var limit = picker
          ? picker.getBoundingClientRect().top + window.scrollY - offset - 12
          : reveal;
        top = Math.min(Math.max(top, reveal), limit);
      }
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  }

  function boot() {
    initBuyScroll();
    document.querySelectorAll('[data-lv-scroll-to-reviews]').forEach(initScrollToReviews);
    document.querySelectorAll('[data-lv-text-0]').forEach(initVariantText);
    document.querySelectorAll('[data-lv-min-version]').forEach(initVariantGate);
    document.querySelectorAll('[data-lv-price-tpl]').forEach(initVariantPriceLabel);
    document.querySelectorAll('[data-lv-bundle-add]').forEach(initBundleAdd);
    document.querySelectorAll('[data-lv-img-0]').forEach(initVariantImages);
    document.querySelectorAll('[data-lv-modal-open]').forEach(initModal);
    document.querySelectorAll('[data-lv-buybox]').forEach(initBuybox);
    document.querySelectorAll('[data-lv-swap-gallery]').forEach(initSwapGallery);
    document.querySelectorAll('[data-lv-video]').forEach(initVideo);
    document.querySelectorAll('[data-lv-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-lv-testi]').forEach(initTesti);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the theme editor injects/reloads a section
  document.addEventListener('shopify:section:load', boot);
})();
